import { createUseStyles } from 'react-jss';

const styles = {
  emailWarningText: {
    marginTop: '1rem'
  },
  label: {
    flex: '1',
    marginRight: '1rem',
    justifyContent: 'flex-end',
    display: 'inline-grid'
  },
  input: { flex: '3' }
};

export const useStyles = createUseStyles(styles, {
  name: 'AssignDialog'
});
